import { render, staticRenderFns } from "./settingList.vue?vue&type=template&id=1657fa31&scoped=true&"
import script from "./settingList.vue?vue&type=script&lang=js&"
export * from "./settingList.vue?vue&type=script&lang=js&"
import style0 from "./settingList.vue?vue&type=style&index=0&id=1657fa31&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1657fa31",
  null
  
)

export default component.exports